import React from 'react';
import CatalogBrowser from '../components/shop/CatalogBrowser';
import SEO from '../components/SEO';

export default function Shop() {
    return (
        <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-10 py-10 lg:py-16" data-testid="shop-page">
            <SEO title="Shop All" description="Browse the full by anfal collection — abayas, evening gowns, modest sets and more, hand-finished in our atelier." canonical="/shop" />
            <div className="text-center mb-8">
                <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>Shop All</p>
                <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-2" style={{ color: 'var(--brand-burgundy)' }}>The Edit</h1>
                <hr className="divider-burgundy mt-5 mx-auto" />
            </div>
            <CatalogBrowser />
        </div>
    );
}
